import { GetReportsParams, GetReportsTypes } from './reports.type';
import { IGetReportsAction } from './reports.interface';

export const getReports = (payload: GetReportsParams): IGetReportsAction => ({
	type: GetReportsTypes.GET_REPORTS,
	payload,
});
